module.exports = __webpack_public_path__ + "img/capa1.ac50baba.webp";